<template>
  <b-form-group class="col-sm-12 field3 optimizer-form-group">
    <b-form-group
      :state="$_hasError('numberOfCopies')"
      class="h-display-sm campaign-form optimizer-form-group"
    >
      <template slot="label">
        Number of Copies
        <i class="fa fa-info-circle ml-1" v-b-tooltip.hover.top :title="$_getTooltipText()"></i>
      </template>
      <b-input-group>
        <template>
          <b-form-input
            class="field3-input optimizer-form-input"
            type="number"
            v-model="numberOfCopies"
            name="numberOfCopies"
            v-validate="'required'"
            :step="1"
          >
          </b-form-input>
        </template>
      </b-input-group>
    </b-form-group>
    <div>
      <div class="d-flex align-items-center mb-3 ml-2" v-if="$c_optionalBudget">
        <p>Enable Budget</p>
        <switch-button
          class="min-max-switch ml-2 mb-1"
          :checked="$c_enabledBudget"
          :hover-title="{ enabled: 'Disable', disabled: 'Enable' }"
          :update="(value) => $_switchToggle(value)"
        />
      </div>
      <RuleBudget v-if="$c_enabledBudget" v-model="ruleModel.rule.components.numberOfCopies.budget.value" :config="config" :mode="mode" :ruleModel="ruleModelForBudget" />
    </div>
  </b-form-group>
</template>

<script>
import component from '../mixins/component';
import RuleBudget from './RuleBudget.vue';

export default {
  name: 'RuleNumberOfCopies',
  components: { RuleBudget },
  mixins: [component],
  props: {
    value: { type: Number, default: 1 },
    ruleModel: { type: Object, required: true },
    config: { type: Object, required: true },
    mode: { type: String, required: true },
  },
  data() {
    return {
      numberOfCopies: 1,
      ruleModelForBudget: {
        rule: {
          components: {
            budget: this.ruleModel.rule.components.numberOfCopies?.budget,
          },
        },
      },
    };
  },
  computed: {
    $c_optionalBudget() {
      const supportedTs = ['TikTok'];
      const allowBudget = this.ruleModel.rule.ts_types.length === 1 && supportedTs.includes(this.ruleModel.rule.ts_types[0]);
      if (!allowBudget) return false;
      return (this.ruleModelForBudget.rule.components.budget?.isOptional && allowBudget) || false;
    },
    $c_enabledBudget() {
      const hasOptionalBudget = this.$c_optionalBudget;
      if (hasOptionalBudget) {
        return this.ruleModelForBudget.rule.components.budget.enableBudget;
      }
      return false;
    },
  },
  watch: {
    numberOfCopies: {
      immediate: true,
      handler() {
        this.$_emit('numberOfCopies');
      },
      deep: true,
    },
  },
  created() {
    this.numberOfCopies = this.value;
  },
  methods: {
    $_getTooltipText() {
      const entity = this.ruleModel.rule?.indefinite_level_rename || this.ruleModel.rule.level;
      const entityName = (entity.replace('an ', '')).replace('a ', '');
      const text = 'Specify the number of cloned copies for each {entity}. Example: 5 means that each {entity} will be cloned 5 times.';
      return text.replaceAll('{entity}', entityName.toLowerCase());
    },
    $_switchToggle(value) {
      this.ruleModelForBudget.rule.components.budget.enableBudget = value;
    },
  },
};
</script>
